<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ item.name }}</div>
            <a-table
              v-for="account in Object.values(item.sub_accounts)"
              :dataSource="account.transactions"
              :columns="columns"
              :pagination="false"

              class="tbl-receivable flex flex-col gap-y-6"
            >
              <template slot="description" slot-scope="text,record">
                {{ limitTextTask(record.description) }}
              </template>
              <template slot="amount" slot-scope="text,record">
<!--                {{ Math.abs(record.amount) }}-->
                {{ record.amount }}
              </template>
              <template slot="date" slot-scope="text,record">
                {{ setDateFormat(record.created_at) }}
              </template>
              <template slot="footer">
                <template v-if="account.transactions.length">
                  <div class="grid grid-cols-3">
                    <div class="font-bold">Total:</div>
                    <div class="place-self-end">{{ currencySymbol + sumCol(account.transactions,'amount') }}</div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Trust accounts">
              <a-radio-group v-decorator="['which_account',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeAccount">
                <a-radio :style="radioStyle" :value="1">
                  All accounts
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific account
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="account_value === 2"
              :required="false"
              url="/bank-account/query/"
              :options="{placeholder: 'Search accounts',label: 'accounts',field: 'account',width: '100%',allow_clear: true}"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_bank_account="true"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-4"/>
          <div class="mt-10">
            <a-form-item>
              <a-checkbox>Include Opening Balance</a-checkbox>
            </a-form-item>
            <a-form-item>
              <a-checkbox>Display Matter to Matter Transfer Transactions</a-checkbox>
            </a-form-item>
          </div>

        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [

  {
    title: 'Date',
    dataIndex: 'created_at',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: '2',
  },
  {
    title: 'Matter',
    dataIndex: 'matter',
    key: '3',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '4',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: '5',
    scopedSlots: { customRender: 'amount' },
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    key: '6',
  },
]

export default {
  name: "ComponentBankAccountActivity",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      account_value    : null,
      checked_matter_client: null,
      title:'Bank Account Activity',
      result: [],
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  computed: {
    currencySymbol() {
      return localStorage.getItem('currency_symbol')
    },
  },
  methods:{
    handleChangeAccount({target:{value}}){
      this.account_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.account) query.push({ field:'id', condition: '=', value: values.account })
            const {data}    = await axios.post('contact/report/bank-account-activity',{
              query: query.length ? query : undefined,
              practice_area: values.practice_area || undefined,
              from: values.from_date,
              to: values.to_date
            })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
